import Colors from './Colors';
import * as Settings from './Settings';
import Styles from './Styles';

export default { Settings, Colors, Styles };
